import { render, staticRenderFns } from "./qualificationDocuments.vue?vue&type=template&id=4bb49ac6&scoped=true&"
import script from "./qualificationDocuments.vue?vue&type=script&lang=js&"
export * from "./qualificationDocuments.vue?vue&type=script&lang=js&"
import style0 from "./qualificationDocuments.vue?vue&type=style&index=0&id=4bb49ac6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb49ac6",
  null
  
)

export default component.exports